// Compiled at 2026-10-07T06:21:14.844Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import { BoInfoSymbol } from "@lg/shared";

export class MenuState {
    static readonly [BoInfoSymbol] = Object.freeze({
        boType: "UserDefinedConfiguration" as const,
    });
    static readonly __type = 'Toolbox.MenuState';
    private static valuePromise?: Promise<MenuState.ValueType>;

    static get(): Promise<MenuState.ValueType> {
        if (!this.valuePromise) {
            this.valuePromise = ExecutionService.executeMethodAndReturnData<MenuState.ValueType>('UserDefinedConfiguration', 'Toolbox', 'MenuState', undefined, 'get', [])
        }

        return this.valuePromise
    }

    static async set(value: MenuState.ValueType): Promise<void> {
        this.valuePromise = Promise.resolve(value)
        await ExecutionService.executeMethodAndReturnData<MenuState.ValueType>('UserDefinedConfiguration', 'Toolbox', 'MenuState', undefined, 'set', [value])
    }
}

export namespace MenuState {
    export type ValueType = any
}
